import React from "react";
import { useTranslation } from "react-i18next";

// for styles
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@material-ui/core/";

// sass
import "../../scss/common.scss";
import "../../scss/component.scss";


// モーダルに何か渡したい場合はここ追加する
type Props = {
  isShow: boolean,
  optionCode:string,
  optionName:string
  callback: () => void,
  optionCancel(optionCode:string): void
}

// ダイアログ:追加済みレンタカーのキャンセル
const DialogOptionCancel: React.FC<Props> = ({
  isShow,
  callback,
  optionCode,
  optionName,
  optionCancel,
}) => {

  const { t } = useTranslation();

  return (
    <div>
      <Dialog
        open={isShow}
        onClose={callback}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="dialog"
      >
        <DialogTitle id="alert-dialog-title" className="dialog-title">
          {t("DialogOptionCancel.追加済みオプションのキャンセル")}
        </DialogTitle>
        <DialogContent className="dialog-content">
          <DialogContentText id="alert-dialog-description" className="dialog-content-text">
            {/* {carRentalName}をキャンセルしてもよろしいですか？ */}
            {t("DialogOptionCancel.nameをキャンセルしてもよろしいですか？", { name: optionName })}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action">
          <Button className="button-dialog-border-small-blue w-110" onClick={callback}>{t("DialogOptionCancel.いいえ")}</Button>
          <Button className="button-dialog-small-blue w-110" onClick={() => optionCancel(optionCode)} autoFocus>
            {t("DialogOptionCancel.はい")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DialogOptionCancel;
